import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { IQuestionChoices } from '../../../interfaces/radio-checkbox-config.interface';
import { EnumsState } from '../../../store/state/enums.state';

@Component({
    selector: 'app-education-level',
    templateUrl: './education-level.component.html',
    styleUrls: ['./education-level.component.scss'],
})
export class EducationLevelComponent {
    @Select(EnumsState.educationLevels) public educationLevels$: Observable<IQuestionChoices[]>;
    @Input() public control: FormControl;
    @Input() public readonly = false;
    @Output() public elementSizeModification = new EventEmitter<void>();
}
